'use client'
import type { FC } from 'react'
import React from 'react'
import cn from 'classnames'
import LoginInfo from './loginInfo'
import LangSwitch from '@/app/[lang]/(login)/components/langSwitch'
import Gift from './gift'
import NavHeader from './nav-header'
import { Mail, Crown } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import Link from 'next/link'
import { tgWeb, isMilian, isHuanmeng } from '@/app/module/global'
import { isTG } from '@share/src/module/global'
import useSWR from 'swr'
import useRequest from '@little-tavern/shared/src/hook/useRequest'
import { useAuthContext } from '@share/src/authContext'

interface UnreadCountData {
  notification: number
  update: number
  private_message: number
  total: number
}
export type IHeaderProps = {
  lang: string
}
const Header: FC<IHeaderProps> = ({ lang }) => {
  const { t } = useTranslation()
  const auth = useAuthContext()
  const request = useRequest()
  const isLogin = auth?.isLogin;

  const { data: unreadCount } = useSWR<UnreadCountData>(
    isLogin ? '/inbox/messages/unread_count' : null,
    (url) => request(url).then(res => res.data),
    {
      revalidateOnFocus: true,
      fallbackData: {
        notification: 0,
        update: 0,
        private_message: 0,
        total: 0
      }
    }
  )

  const hasUnread = unreadCount && unreadCount.total > 0

  return (
    <>
      <div className="fixed-top z-10 w-full left-0 dark:border-b dark:border-purple-500/15 space-x-2 bg-white dark:bg-[var(--nav-bg)] drop-shadow-u dark:drop-shadow-none">
        <div className='mx-auto flex items-center justify-between h-[43px]'>
          <NavHeader lang={lang} />
          <div className='flex items-center'>
            {/* <Gift /> */}
            <Link href={`/${lang}/pay`} className='mr-1.5 items-center flex text-xs !rounded-full px-2.5 py-1 sm:p-3 sm:py-1 sm:ml-1.5 sm:mr-1.5 text-white relative z-20 btn-bg-0 flex justify-center'>
              <span className='animate-wiggle-more animate-thrice mr-0.5'>💎</span>
              {t('app.nav.discount')}
            </Link>
            {(isHuanmeng || isTG) && <Link href={`/${lang}/new-vip`} className='vip-entry-btn mr-1 flex items-center justify-center text-[11px] font-extrabold px-2 py-0.5 rounded-md transition-all active:scale-95'>
              <Crown className='w-3 h-3 mr-0.5' strokeWidth={2.5} />VIP
            </Link>}
            <Link href={`/${lang}/message`} className='flex px-1.5 text-sm items-center py-4 relative text-gray-400 text-center text-gray-500 cursor-pointer'>
              {hasUnread && <div className='absolute left-5 top-4 w-1.5 h-1.5 bg-red-500 rounded-full' />}
              <Mail className='w-5 h-5 mr-0.5' />
              {/* {t('app.common.message')} */}
            </Link>
            {/* {!isMilian && (tgWeb ? <Link href={`https://docs.uhoney.ai/`} className='flex px-1.5 text-sm items-center py-4 relative dark:text-gray-400 text-gray-500 text-center cursor-pointer' target='_blank'>
              <BookOpen className='w-4 h-4 mr-0.5' />
              {t('app.nav.guide')}
            </Link> : <Link href={`https://docs.huanmeng.ai`} className='flex px-1.5 text-sm items-center py-4 relative text-zinc-500 text-center text-gray-500 cursor-pointer' target='_blank'>
              <BookOpen className='w-4 h-4 mr-0.5' />
              {t('app.nav.guide')}
            </Link>)}
            <div className={cn('px-1.5 text-gray-400 font-normal text-sm items-center')}>
              <ThemeSwitch></ThemeSwitch>
            </div> */}
            <LangSwitch />
            <LoginInfo />
          </div>
        </div>
      </div>
    </>
  )
}

export default React.memo(Header, (prevProps, nextProps) => {
  return prevProps.lang === nextProps.lang
})